import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;
  Components.addType("branch-list", {
    model: {
      defaults: {
        draggable: true,
        droppable: false,
        components: html`
          <section class="py-6 container mx-auto px-4 ">
            <div class="overflow-x-auto">
              <table
                class="min-w-full border border-gray-300 text-sm text-left"
              >
                <thead>
                  <tr class=" text-gray-700">
                    <th class="px-4 py-2 border">S.N</th>
                    <th class="px-4 py-2 border">Location Name</th>
                    <th class="px-4 py-2 border">Branch Manager</th>
                    <th class="px-4 py-2 border">Phone Number</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="bg-gray-100 font-semibold">
                    <td colspan="4" class="px-4 py-2 border">Eastern Region</td>
                  </tr>
                  <tr>
                    <td class="px-4 py-2 border">1</td>
                    <td class="px-4 py-2 border">Birtamode</td>
                    <td class="px-4 py-2 border">Ganesh Gautam</td>
                    <td class="px-4 py-2 border">9852677355</td>
                  </tr>
                  <tr>
                    <td class="px-4 py-2 border">2</td>
                    <td class="px-4 py-2 border">Damak</td>
                    <td class="px-4 py-2 border">Padam Adhikari</td>
                    <td class="px-4 py-2 border">9808585075</td>
                  </tr>
                  <tr>
                    <td class="px-4 py-2 border">3</td>
                    <td class="px-4 py-2 border">Itahari</td>
                    <td class="px-4 py-2 border">Suraj Koirala</td>
                    <td class="px-4 py-2 border">9802723882</td>
                  </tr>
                  <tr>
                    <td class="px-4 py-2 border">4</td>
                    <td class="px-4 py-2 border">Biratnagar</td>
                    <td class="px-4 py-2 border">Diran Dev</td>
                    <td class="px-4 py-2 border">9842465252</td>
                  </tr>
                  <tr>
                    <td class="px-4 py-2 border">5</td>
                    <td class="px-4 py-2 border">Lahan</td>
                    <td class="px-4 py-2 border">Rajkumar Yadav</td>
                    <td class="px-4 py-2 border">9842826494</td>
                  </tr>

                  <tr class="bg-gray-100 font-semibold">
                    <td colspan="4" class="px-4 py-2 border">
                      Central & Terai Region
                    </td>
                  </tr>
                  <tr>
                    <td class="px-4 py-2 border">1</td>
                    <td class="px-4 py-2 border">Janakpur</td>
                    <td class="px-4 py-2 border">Sharwan Raut</td>
                    <td class="px-4 py-2 border">9854026009</td>
                  </tr>
                  <tr>
                    <td class="px-4 py-2 border">2</td>
                    <td class="px-4 py-2 border">Birgunj</td>
                    <td class="px-4 py-2 border">Bunilal Mukhiya</td>
                    <td class="px-4 py-2 border">9855020423</td>
                  </tr>
                  <tr>
                    <td class="px-4 py-2 border">3</td>
                    <td class="px-4 py-2 border">Hetauda</td>
                    <td class="px-4 py-2 border">R.P. Pudasaini</td>
                    <td class="px-4 py-2 border">9845123971</td>
                  </tr>
                  <tr>
                    <td class="px-4 py-2 border">4</td>
                    <td class="px-4 py-2 border">Narayanghat</td>
                    <td class="px-4 py-2 border">Santosh Shrestha</td>
                    <td class="px-4 py-2 border">9808316565</td>
                  </tr>

                  <tr class="bg-gray-100 font-semibold">
                    <td colspan="4" class="px-4 py-2 border">
                      Western & Hilly Region
                    </td>
                  </tr>
                  <tr>
                    <td class="px-4 py-2 border">1</td>
                    <td class="px-4 py-2 border">Butwal</td>
                    <td class="px-4 py-2 border">Besh Bdr. Thapa</td>
                    <td class="px-4 py-2 border">9857039224</td>
                  </tr>
                  <tr>
                    <td class="px-4 py-2 border">2</td>
                    <td class="px-4 py-2 border">Bhairahawa</td>
                    <td class="px-4 py-2 border">Sanjay Rana Magar</td>
                    <td class="px-4 py-2 border">9847018119</td>
                  </tr>
                  <tr>
                    <td class="px-4 py-2 border">3</td>
                    <td class="px-4 py-2 border">Pokhara</td>
                    <td class="px-4 py-2 border">Tilak Baral</td>
                    <td class="px-4 py-2 border">9849148906</td>
                  </tr>

                  <tr class="bg-gray-100 font-semibold">
                    <td colspan="4" class="px-4 py-2 border">
                      Mid-Western Region
                    </td>
                  </tr>
                  <tr>
                    <td class="px-4 py-2 border">1</td>
                    <td class="px-4 py-2 border">Dang</td>
                    <td class="px-4 py-2 border">Chandra B.K.</td>
                    <td class="px-4 py-2 border">9847820543</td>
                  </tr>
                  <tr>
                    <td class="px-4 py-2 border">2</td>
                    <td class="px-4 py-2 border">Surkhet</td>
                    <td class="px-4 py-2 border">Krishan Adhikari</td>
                    <td class="px-4 py-2 border">9848047519</td>
                  </tr>
                  <tr>
                    <td class="px-4 py-2 border">3</td>
                    <td class="px-4 py-2 border">Nepalgunj</td>
                    <td class="px-4 py-2 border">Puran Shrestha</td>
                    <td class="px-4 py-2 border">9858024202</td>
                  </tr>

                  <tr class="bg-gray-100 font-semibold">
                    <td colspan="4" class="px-4 py-2 border">
                      Far-Western Region
                    </td>
                  </tr>
                  <tr>
                    <td class="px-4 py-2 border">1</td>
                    <td class="px-4 py-2 border">Dhangadhi</td>
                    <td class="px-4 py-2 border">Bhojraj Sahi</td>
                    <td class="px-4 py-2 border">9858424410</td>
                  </tr>
                  <tr>
                    <td class="px-4 py-2 border">2</td>
                    <td class="px-4 py-2 border">Mahendranagar</td>
                    <td class="px-4 py-2 border">Padam Kharel</td>
                    <td class="px-4 py-2 border">9848722554</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        `,
        // traits: [
        //   {
        //     type: "text",
        //     name: "icon",
        //     label: "Icon",
        //     changeProp: true,
        //   },
        //   {
        //     type: "text",
        //     name: "title",
        //     label: "Title",
        //     changeProp: true,
        //   },
        // ],
      },
    },
  });
};
